import apiClient from 'utilities/apiClient';

export const adminGet = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.admin}/${url}`, payload, true);
};

export const adminPost = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.admin}/${url}`, payload, true);
};
